import { render, staticRenderFns } from "./repeatDetail.vue?vue&type=template&id=6524b8de&scoped=true&"
import script from "./repeatDetail.vue?vue&type=script&lang=js&"
export * from "./repeatDetail.vue?vue&type=script&lang=js&"
import style0 from "./repeatDetail.vue?vue&type=style&index=0&id=6524b8de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524b8de",
  null
  
)

export default component.exports